import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.review.result.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-review-result-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.review.result.item/view.scss */
:host {
  display: block;
  min-width: 0;
  color: #1b241e;
  background: #f4f6f2;
}

.review-result-page {
  min-height: 100%;
  background: #f4f6f2;
}

.review-result-shell {
  width: min(1420px, 100% - 56px);
  margin: 0 auto;
}

.review-result-header {
  z-index: 5;
  border-bottom: 1px solid #e2e7df;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(18px);
}

.review-result-heading {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 18px;
}

.review-result-heading__copy {
  min-width: 0;
}

.review-result-back {
  display: inline-flex;
  width: 46px;
  height: 46px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #d7ded5;
  border-radius: 14px;
  color: #4e5e53;
  background: #fff;
  box-shadow: 0 5px 14px rgba(29, 47, 35, 0.06);
  transition: border-color 0.18s ease, color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
}

.review-result-back:hover {
  border-color: #b6c4b9;
  color: #173f30;
  box-shadow: 0 8px 20px rgba(29, 47, 35, 0.1);
  transform: translateY(-1px);
}

.review-result-heading__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  color: #7c877f;
  font-size: 12px;
  font-weight: 700;
}

.review-result-heading__meta > span:not(.review-result-kind)::before {
  display: inline-block;
  width: 3px;
  height: 3px;
  margin-right: 10px;
  border-radius: 50%;
  background: #b1bab2;
  vertical-align: middle;
  content: "";
}

.review-result-kind {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 6px 10px;
  color: #fff;
  background: #e35d38;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.review-result-kind.is-kg {
  background: #247363;
}

.review-result-heading h1 {
  margin: 0;
}

.review-result-heading p {
  overflow: hidden;
  margin: 9px 0 0;
  color: #6e7971;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.review-result-header__actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 10px;
}

.review-result-finalized,
.review-result-print {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  gap: 9px;
  border-radius: 12px;
  padding: 0 15px;
  font-size: 12px;
  font-weight: 700;
}

.review-result-finalized {
  border: 1px solid #cee1d4;
  color: #286343;
  background: #eff7f1;
}

.review-result-print {
  border: 1px solid #d6ddd5;
  color: #4c5b50;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
}

.review-result-print:hover {
  border-color: #abbbae;
  color: #173f30;
  box-shadow: 0 5px 14px rgba(29, 47, 35, 0.08);
}

.review-result-overview {
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(310px, 0.7fr);
  gap: 18px;
}

.review-result-decision-card,
.review-result-score-card,
.review-result-audit-card,
.review-result-panel,
.review-result-empty {
  border: 1px solid #dfe5dc;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 12px 32px rgba(31, 47, 36, 0.06);
}

.review-result-decision-card {
  position: relative;
  overflow: hidden;
  padding: 28px;
  border-top: 4px solid #2f7657;
}

.review-result-decision-card::after {
  position: absolute;
  top: 0;
  right: 0;
  width: 160px;
  height: 4px;
  background: #9cc4aa;
  content: "";
}

.review-result-decision-card.is-revise {
  border-top-color: #c58128;
}

.review-result-decision-card.is-revise::after {
  background: #ead09c;
}

.review-result-decision-card.is-exclude {
  border-top-color: #bb5848;
}

.review-result-decision-card.is-exclude::after {
  background: #e6aaa0;
}

.review-result-decision-main {
  display: grid;
  grid-template-columns: 64px minmax(0, 1fr);
  align-items: center;
  gap: 20px;
}

.review-result-decision-icon {
  display: flex;
  width: 64px;
  height: 64px;
  align-items: center;
  justify-content: center;
  border-radius: 19px;
  color: #2e7655;
  background: #edf6ef;
  font-size: 24px;
}

.is-revise .review-result-decision-icon {
  color: #95601c;
  background: #fff5e5;
}

.is-exclude .review-result-decision-icon {
  color: #9c4537;
  background: #fff0ed;
}

.review-result-eyebrow {
  margin: 0 0 8px;
  color: #df5b36;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
}

.review-result-decision-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.review-result-decision-title h2 {
  margin: 0;
  color: #1f2822;
  font-size: clamp(22px, 2vw, 28px);
  font-weight: 700;
  letter-spacing: -0.04em;
}

.review-result-decision-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 6px 9px;
  color: #2c6c4c;
  background: #eef7f1;
  font-size: 12px;
  font-weight: 700;
}

.is-revise .review-result-decision-badge {
  color: #8b5a1d;
  background: #fff5e5;
}

.is-exclude .review-result-decision-badge {
  color: #9c4537;
  background: #fff0ed;
}

.review-result-decision-description {
  max-width: 760px;
  margin: 9px 0 0;
  color: #667269;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.65;
}

.review-result-decision-meta {
  display: grid;
  grid-template-columns: 0.8fr 1.35fr 0.8fr;
  gap: 10px;
  margin: 24px 0 0 84px;
}

.review-result-decision-meta div {
  min-width: 0;
  border: 1px solid #e6ebe4;
  border-radius: 12px;
  padding: 11px 13px;
  background: #f8faf7;
}

.review-result-decision-meta dt,
.review-result-audit-card dt,
.review-result-task-info dt {
  color: #8b958d;
  font-size: 12px;
  font-weight: 700;
}

.review-result-decision-meta dd,
.review-result-audit-card dd,
.review-result-task-info dd {
  overflow: hidden;
  margin: 5px 0 0;
  color: #314038;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
}

.review-result-score-card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  padding: 27px;
  color: #fff;
  border-color: #183b2e;
  background: #183b2e;
  box-shadow: 0 16px 34px rgba(24, 59, 46, 0.18);
}

.review-result-score-card.is-revise {
  border-color: #6c4c1f;
  background: #6c4c1f;
}

.review-result-score-card.is-exclude {
  border-color: #65362e;
  background: #65362e;
}

.review-result-score-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.review-result-score-card h2 {
  margin: 0;
  color: #fff;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.review-result-score-card .review-result-eyebrow {
  color: #f09a7e;
}

.review-result-status {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 999px;
  padding: 7px 9px;
  color: #d8eee0;
  background: rgba(255, 255, 255, 0.08);
  font-size: 12px;
  font-weight: 700;
}

.review-result-score {
  display: flex;
  align-items: baseline;
  gap: 7px;
  margin-top: 24px;
}

.review-result-score strong {
  font-size: clamp(52px, 4.2vw, 66px);
  font-weight: 700;
  line-height: 0.9;
  letter-spacing: -0.065em;
}

.review-result-score span {
  color: rgba(255, 255, 255, 0.58);
  font-size: 12px;
  font-weight: 700;
}

.review-result-score-track,
.review-result-dimension-track {
  overflow: hidden;
  border-radius: 999px;
  background: #e6eae4;
}

.review-result-score-track {
  height: 7px;
  margin-top: 22px;
  background: rgba(255, 255, 255, 0.15);
}

.review-result-score-track i,
.review-result-dimension-track i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #e9704d;
}

.review-result-score-footer {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: auto;
  padding-top: 21px;
}

.review-result-score-footer > span {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.review-result-score-footer small {
  color: rgba(255, 255, 255, 0.56);
  font-size: 12px;
  font-weight: 700;
}

.review-result-score-footer strong {
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.review-result-audit-card {
  display: grid;
  grid-template-columns: 210px minmax(0, 1fr);
  align-items: stretch;
  margin-top: 18px;
  overflow: hidden;
}

.review-result-audit-heading {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 22px 24px;
  border-right: 1px solid #e6ebe4;
  background: #fafbf9;
}

.review-result-audit-heading h2,
.review-result-panel__header h2 {
  margin: 0;
  color: #202922;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.review-result-audit-heading > span {
  margin-top: 7px;
  color: #879189;
  font-size: 12px;
  font-weight: 600;
}

.review-result-audit-card dl {
  display: grid;
  grid-template-columns: 0.8fr 1.2fr 1.2fr 0.75fr 0.9fr;
  margin: 0;
}

.review-result-audit-card dl > div {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 20px 17px;
  border-right: 1px solid #edf0eb;
}

.review-result-audit-card dl > div:last-child {
  border-right: 0;
}

.review-result-audit-card dl > div > i {
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #3e7557;
  background: #eef5ef;
  font-size: 12px;
}

.review-result-audit-card span {
  min-width: 0;
}

.review-result-audit-card dd {
  white-space: nowrap;
}

.review-result-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(330px, 0.72fr);
  gap: 18px;
  margin-top: 18px;
}

.review-result-panel {
  overflow: hidden;
}

.review-result-panel__header {
  display: flex;
  min-height: 82px;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 0 24px;
  border-bottom: 1px solid #e6eae4;
}

.review-result-panel__header small {
  display: block;
  margin-top: 6px;
  color: #8b948c;
  font-size: 12px;
  font-weight: 600;
}

.review-result-scale {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border-radius: 999px;
  padding: 7px 10px;
  color: #657168;
  background: #f3f6f2;
  font-size: 12px;
  font-weight: 700;
}

.review-result-dimension-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 22px;
  padding: 8px 24px 22px;
}

.review-result-dimension-list article {
  min-width: 0;
  padding: 19px 4px;
  border-bottom: 1px solid #edf0eb;
}

.review-result-dimension-list article:nth-last-child(-n+2) {
  border-bottom: 0;
}

.review-result-dimension-heading {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
}

.review-result-dimension-index {
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #fff;
  background: #294d3b;
  font-size: 12px;
  font-weight: 700;
}

.review-result-dimension-heading > div {
  min-width: 0;
}

.review-result-dimension-heading > div strong,
.review-result-dimension-heading > div small {
  display: block;
}

.review-result-dimension-heading > div strong {
  color: #29342d;
  font-size: 12px;
  font-weight: 700;
}

.review-result-dimension-heading > div small {
  overflow: hidden;
  margin-top: 5px;
  color: #8a938b;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.review-result-dimension-heading em {
  display: flex;
  align-items: baseline;
  gap: 3px;
  color: #355c46;
  font-style: normal;
}

.review-result-dimension-heading em strong {
  font-size: 13px;
  font-weight: 700;
}

.review-result-dimension-heading em span {
  color: #869088;
  font-size: 12px;
  font-weight: 700;
}

.review-result-dimension-track {
  height: 6px;
  margin: 13px 0 0 44px;
}

.review-result-dimension-track i {
  background: #3e7557;
}

.review-result-side {
  display: grid;
  align-content: start;
  gap: 18px;
}

.review-result-count {
  display: inline-flex;
  min-width: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 6px 9px;
  color: #477458;
  background: #eef6f0;
  font-size: 12px;
  font-weight: 700;
}

.review-result-count.has-issues {
  color: #a54d35;
  background: #fff1ec;
}

.review-result-tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 22px 24px 24px;
}

.review-result-tag-list span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #efc3b5;
  border-radius: 999px;
  padding: 8px 11px;
  color: #a24931;
  background: #fff4ef;
  font-size: 12px;
  font-weight: 700;
}

.review-result-none {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  padding: 24px;
}

.review-result-none > span {
  display: flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  color: #fff;
  background: #3d7757;
  font-size: 13px;
}

.review-result-none strong,
.review-result-none small {
  display: block;
}

.review-result-none strong {
  color: #365b46;
  font-size: 12px;
  font-weight: 700;
}

.review-result-none small {
  margin-top: 5px;
  color: #879189;
  font-size: 12px;
  font-weight: 600;
}

.review-result-task-info dl {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  margin: 0;
  background: #e7ebe5;
}

.review-result-task-info dl div {
  min-width: 0;
  padding: 17px 18px;
  background: #fff;
}

.review-result-task-info dd {
  line-height: 1.45;
  white-space: normal;
}

.review-result-notes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
  margin-top: 18px;
}

.review-result-note-icon {
  display: flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  color: #3c7155;
  background: #eef5ef;
  font-size: 12px;
}

.review-result-note-card blockquote {
  min-height: 96px;
  margin: 0;
  padding: 22px 24px 25px;
  color: #4c5850;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.8;
  word-break: keep-all;
}

.review-result-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-top: 18px;
  padding: 16px 20px;
  border: 1px solid #dfe5dc;
  border-radius: 15px;
  color: #6c786f;
  background: rgba(255, 255, 255, 0.78);
  font-size: 12px;
  font-weight: 700;
}

.review-result-footer div,
.review-result-footer a {
  display: flex;
  align-items: center;
  gap: 9px;
}

.review-result-footer div > i {
  color: #397154;
}

.review-result-footer a {
  flex: 0 0 auto;
  color: #d95531;
  font-weight: 700;
  transition: gap 0.18s ease;
}

.review-result-footer a:hover {
  gap: 12px;
}

.review-result-empty {
  display: flex;
  min-height: 480px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 36px;
  text-align: center;
}

.review-result-empty > span {
  display: flex;
  width: 72px;
  height: 72px;
  align-items: center;
  justify-content: center;
  border-radius: 22px;
  color: #667668;
  background: #eff3ed;
  font-size: 26px;
}

.review-result-empty h2 {
  margin: 20px 0 0;
  font-size: 22px;
  font-weight: 700;
}

.review-result-empty p {
  max-width: 520px;
  margin: 10px 0 0;
  color: #778077;
  font-size: 12px;
  line-height: 1.7;
}

.review-result-empty a,
.review-result-empty button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 22px;
  border: 0;
  border-radius: 12px;
  padding: 13px 18px;
  color: #fff;
  background: #294b39;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

@media (max-width: 1220px) {
  .review-result-overview {
    grid-template-columns: minmax(0, 1.3fr) minmax(290px, 0.7fr);
  }
  .review-result-audit-card {
    grid-template-columns: 180px minmax(0, 1fr);
  }
  .review-result-audit-card dl {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .review-result-audit-card dl > div:nth-child(3) {
    border-right: 0;
  }
  .review-result-audit-card dl > div:nth-child(n+4) {
    border-top: 1px solid #edf0eb;
  }
}
@media (max-width: 980px) {
  .review-result-shell {
    width: min(100% - 36px, 1420px);
  }
  .review-result-overview,
  .review-result-grid {
    grid-template-columns: 1fr;
  }
  .review-result-score-card {
    min-height: 290px;
  }
  .review-result-audit-card {
    grid-template-columns: 1fr;
  }
  .review-result-audit-heading {
    border-right: 0;
    border-bottom: 1px solid #e6ebe4;
  }
  .review-result-dimensions {
    order: 1;
  }
}
@media (max-width: 760px) {
  .review-result-shell {
    width: min(100% - 24px, 1420px);
  }
  .review-result-heading {
    align-items: flex-start;
  }
  .review-result-heading__meta > span:last-child {
    width: 100%;
  }
  .review-result-heading__meta > span:last-child::before {
    display: none;
  }
  .review-result-heading p {
    white-space: normal;
  }
  .review-result-header__actions {
    width: 100%;
  }
  .review-result-finalized {
    flex: 1;
    justify-content: center;
  }
  .review-result-decision-card,
  .review-result-score-card {
    padding: 22px;
  }
  .review-result-decision-main {
    grid-template-columns: 52px minmax(0, 1fr);
    gap: 14px;
  }
  .review-result-decision-icon {
    width: 52px;
    height: 52px;
    border-radius: 16px;
    font-size: 20px;
  }
  .review-result-decision-meta {
    grid-template-columns: 1fr;
    margin: 20px 0 0;
  }
  .review-result-audit-card dl {
    grid-template-columns: 1fr 1fr;
  }
  .review-result-audit-card dl > div {
    border-top: 1px solid #edf0eb;
  }
  .review-result-audit-card dl > div:nth-child(odd) {
    border-right: 1px solid #edf0eb;
  }
  .review-result-audit-card dl > div:nth-child(even) {
    border-right: 0;
  }
  .review-result-audit-card dl > div:first-child,
  .review-result-audit-card dl > div:nth-child(2) {
    border-top: 0;
  }
  .review-result-dimension-list,
  .review-result-notes {
    grid-template-columns: 1fr;
  }
  .review-result-dimension-list article:nth-last-child(2) {
    border-bottom: 1px solid #edf0eb;
  }
  .review-result-panel__header {
    min-height: 76px;
    padding: 0 18px;
  }
  .review-result-scale {
    display: none;
  }
  .review-result-note-card blockquote {
    padding-right: 18px;
    padding-left: 18px;
  }
  .review-result-footer {
    align-items: flex-start;
    flex-direction: column;
  }
}
@media (max-width: 480px) {
  .review-result-heading {
    gap: 12px;
  }
  .review-result-back {
    width: 40px;
    height: 40px;
    border-radius: 12px;
  }
  .review-result-header__actions {
    align-items: stretch;
  }
  .review-result-finalized,
  .review-result-print {
    padding: 0 11px;
  }
  .review-result-print span {
    display: none;
  }
  .review-result-audit-card dl {
    grid-template-columns: 1fr;
  }
  .review-result-audit-card dl > div {
    border-right: 0 !important;
  }
  .review-result-audit-card dl > div:nth-child(2) {
    border-top: 1px solid #edf0eb;
  }
  .review-result-task-info dl {
    grid-template-columns: 1fr;
  }
  .review-result-dimension-heading {
    grid-template-columns: 30px minmax(0, 1fr) auto;
    gap: 9px;
  }
  .review-result-dimension-index {
    width: 30px;
    height: 30px;
  }
  .review-result-dimension-track {
    margin-left: 39px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .review-result-back,
  .review-result-print,
  .review-result-footer a {
    transition: none;
  }
}
@media print {
  :host,
  .review-result-page {
    color: #111;
    background: #fff;
  }
  .review-result-header__actions button,
  .review-result-back,
  .review-result-footer a {
    display: none !important;
  }
  .review-result-decision-card,
  .review-result-score-card,
  .review-result-audit-card,
  .review-result-panel,
  .review-result-footer {
    break-inside: avoid;
    box-shadow: none;
  }
  .review-result-score-card {
    color: #fff !important;
    print-color-adjust: exact;
  }
}
/* 11: workspace information hierarchy and shared component roles. */
:host-context(.reviewops-shell) .review-result-page .review-result-overview, :host-context(.reviewops-shell) .review-result-page .review-result-grid {
  gap: 24px;
}
:host-context(.reviewops-shell) .review-result-page .review-result-panel, :host-context(.reviewops-shell) .review-result-page .review-result-audit-card, :host-context(.reviewops-shell) .review-result-page .review-result-decision-card, :host-context(.reviewops-shell) .review-result-page .review-result-score-card {
  padding: 24px;
}
:host-context(.reviewops-shell) .review-result-page .review-result-decision-meta, :host-context(.reviewops-shell) .review-result-page .review-result-audit-card dl {
  gap: 16px;
}
:host-context(.reviewops-shell) .review-result-page .review-result-panel__header {
  flex-wrap: wrap;
  gap: 12px;
}
:host-context(.reviewops-shell) .review-result-page .review-result-none small {
  font-size: 14px;
  line-height: 22px;
}
@media (max-width: 1023px) {
  :host-context(.reviewops-shell) .review-result-page .review-result-overview, :host-context(.reviewops-shell) .review-result-page .review-result-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 639px) {
  :host-context(.reviewops-shell) .review-result-page .review-result-panel, :host-context(.reviewops-shell) .review-result-page .review-result-audit-card, :host-context(.reviewops-shell) .review-result-page .review-result-decision-card, :host-context(.reviewops-shell) .review-result-page .review-result-score-card {
    padding: 16px;
  }
}`],
})
export class PageReviewResultItemComponent implements OnInit {
    public kind: 'qa' | 'kg' = 'qa';
    public taskId: string = '';
    public task: any = {};
    public evaluation: any = this.emptyEvaluation();
    public viewedSampleIds: string[] = [];
    public loadError: string = '';
    public loading: boolean = true;
    public surveyDimensions: any[] = [
        { key: 'question_quality', label: '질문 적절성', description: '질문의 명확성과 답변 가능성' },
        { key: 'answer_accuracy', label: '답변 정확성', description: '답변과 원문 사실의 일치도' },
        { key: 'evidence_quality', label: '근거 적절성', description: '근거의 직접성과 충분성' },
        { key: 'qa_composition', label: 'QA 구성 일치성', description: '질문·답변·근거·라벨의 일관성' },
        { key: 'format_quality', label: '표현·형식 완결성', description: '표현과 형식의 완성도' },
        { key: 'overall_quality', label: '종합 활용성', description: '최종 사용 가능 수준' }
    ];
    private workspaceStateLoaded: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.kind = WizRoute.segment.kind === 'kg' ? 'kg' : 'qa';
        this.taskId = WizRoute.segment.id || '';
        this.workspaceStateLoaded = await this.loadWorkspaceResult();
        if (!this.workspaceStateLoaded) {
            await this.service.render();
            return;
        }
        if (!this.task || !this.task.id) {
            await this.service.modal.warning('요청한 검수 작업을 찾을 수 없습니다.', false, '확인');
            this.service.href(this.backRoute());
            return;
        }
        if (!this.canAccessTask()) {
            await this.service.modal.warning('이 검수 결과를 확인할 권한이 없습니다.', false, '확인');
            this.service.href(this.backRoute());
            return;
        }
        await this.service.render();
    }

    private async loadWorkspaceResult() {
        this.loading = true;
        try {
            const response = await fetch('/api/v1/review-workspace/state', {
                method: 'GET',
                headers: { Accept: 'application/json' },
                credentials: 'same-origin'
            });
            const payload = await this.readResponse(response);
            if (!response.ok) throw new Error(this.responseMessage(payload, '검수 결과를 불러오지 못했습니다.'));
            const state = this.unwrapData(payload);
            if (!state || !Array.isArray(state.tasks)) throw new Error('검수 결과 응답 형식이 올바르지 않습니다.');
            const source = state.tasks.find((item: any) => {
                return String(item && item.id || '') === this.taskId
                    && String(item && item.kind || '').toLowerCase() === this.kind;
            });
            if (!source) {
                this.task = {};
                this.evaluation = this.emptyEvaluation();
                this.viewedSampleIds = [];
                return true;
            }
            this.task = this.normalizeTask(source, Array.isArray(state.projects) ? state.projects : []);
            const dimensions = this.surveySnapshotDimensions(source);
            if (dimensions.length) this.surveyDimensions = dimensions;
            const evaluations = state.evaluations && typeof state.evaluations === 'object' ? state.evaluations : {};
            this.evaluation = this.normalizeEvaluation(evaluations[this.task.id]);
            this.viewedSampleIds = this.evaluation.viewed_samples.slice();
            this.loadError = '';
            return true;
        } catch (error) {
            this.task = {};
            this.evaluation = this.emptyEvaluation();
            this.viewedSampleIds = [];
            this.loadError = error instanceof Error ? error.message : '검수 결과를 불러오지 못했습니다.';
            return false;
        } finally {
            this.loading = false;
        }
    }

    public async reloadWorkspaceResult() {
        this.workspaceStateLoaded = await this.loadWorkspaceResult();
        await this.service.render();
    }

    private normalizeTask(task: any, projects: any[]) {
        const projectId = String(task.projectId || task.project_id || '');
        const projectRecord = projects.find((item: any) => String(item && (item.id || item.projectId || item.project_id) || '') === projectId) || {};
        const projectName = typeof task.project === 'string' && task.project.trim()
            ? task.project
            : String(task.projectName || task.project_name || projectRecord.name || projectRecord.title || projectId || '검수 프로젝트');
        const samples = Array.isArray(task.samples) ? task.samples : [];
        const surveyVersion = String(task.surveyVersion || task.survey_version || '');
        const harnessVersion = String(task.harnessVersion || task.harness_version || '');
        return Object.assign({}, task, {
            id: String(task.id || ''),
            projectId: projectId,
            project: projectName,
            dataset: String(task.title || task.dataset || '검수 작업'),
            round: Number(task.round) || this.roundFromId(task.id),
            survey: this.versionedLabel(String(task.survey || task.surveyName || task.survey_name || '검수 설문지'), surveyVersion),
            surveyVersion,
            harness: this.versionedLabel(String(task.harness || task.harnessName || task.harness_name || '검수 하네스'), harnessVersion),
            harnessVersion,
            resultVersion: String(task.resultVersion || task.result_version || task.evaluationVersion || task.evaluation_version || harnessVersion),
            target: Number(task.target) || 90,
            assignee: String(task.assignee || task.reviewer || task.assigneeName || task.assignee_name || '검수 담당자'),
            assigneeId: String(task.assigneeId || task.assignee_id || ''),
            assigneeEmail: String(task.assigneeEmail || task.assignee_email || ''),
            due: this.dateLabel(task.due || task.dueAt || task.due_at),
            sampleCount: Number(task.total ?? task.sampleCount ?? task.sample_count ?? samples.length) || samples.length
        });
    }

    private surveySnapshotDimensions(task: any) {
        const snapshot = task && (task.survey_snapshot || task.surveySnapshot) || {};
        const dimensions = Array.isArray(snapshot.dimensions) ? snapshot.dimensions : [];
        return dimensions.map((dimension: any, index: number) => ({
            key: String(dimension.key || dimension.id || 'dimension_' + (index + 1)),
            label: String(dimension.label || dimension.name || '평가 항목 ' + (index + 1)),
            description: String(dimension.description || dimension.question || '검수 설문 평가 항목'),
            responseOptions: (Array.isArray(dimension.responseOptions) ? dimension.responseOptions : dimension.response_options || [])
                .map((option: any) => ({
                    value: String(option.value || option.code || ''),
                    label: String(option.label || option.name || option.value || '')
                }))
                .filter((option: any) => !!option.value && !!option.label)
        }));
    }

    private normalizeEvaluation(value: any) {
        const source = value && typeof value === 'object' ? value : {};
        const submittedAt = source.submittedAt || source.submitted_at || source.recorded_at || null;
        const viewed = source.viewed_samples || source.viewedSampleIds || [];
        return {
            scores: source.scores && typeof source.scores === 'object' ? source.scores : {},
            responses: source.responses && typeof source.responses === 'object' ? source.responses : {},
            decision: source.decision || null,
            issues: Array.isArray(source.issues) ? source.issues.slice() : [],
            problemLocation: String(source.problemLocation || source.problem_location || ''),
            comment: String(source.comment || ''),
            request: String(source.request || ''),
            submitted: source.submitted === true || !!submittedAt || !!source.task_id,
            submittedAt: submittedAt,
            startedAt: source.startedAt || source.started_at || null,
            durationMinutes: Number(source.durationMinutes ?? source.duration_minutes) || null,
            score: this.optionalNumber(source.score),
            version: String(source.version || source.resultVersion || source.result_version || ''),
            target: Number(source.target) || Number(this.task && this.task.target) || 90,
            viewed_samples: Array.isArray(viewed) ? viewed.slice() : []
        };
    }

    private optionalNumber(value: any) {
        if (value === null || value === undefined || value === '') return null;
        const number = Number(value);
        return Number.isFinite(number) ? number : null;
    }

    private versionedLabel(name: string, version: string) {
        if (!version || name.toLowerCase().endsWith(version.toLowerCase())) return name;
        return name + ' ' + version;
    }

    private roundFromId(id: any) {
        const match = String(id || '').match(/-R(\d+)$/i);
        return match ? Number(match[1]) : 1;
    }

    private dateLabel(value: any) {
        if (!value) return '—';
        const text = String(value);
        const match = text.match(/^(\d{4})[-.](\d{2})[-.](\d{2})/);
        return match ? [match[1], match[2], match[3]].join('.') : text;
    }

    private async readResponse(response: Response) {
        try {
            return await response.json();
        } catch (error) {
            return {};
        }
    }

    private unwrapData(payload: any) {
        const candidates = [
            payload?.data?.data?.state,
            payload?.data?.state,
            payload?.data?.data,
            payload?.result?.state,
            payload?.state,
            payload?.result,
            payload?.data,
            payload
        ];
        const state = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && (
                Object.prototype.hasOwnProperty.call(candidate, 'schema_version')
                || Object.prototype.hasOwnProperty.call(candidate, 'projects')
                || Object.prototype.hasOwnProperty.call(candidate, 'surveys')
                || Object.prototype.hasOwnProperty.call(candidate, 'harnesses')
                || Object.prototype.hasOwnProperty.call(candidate, 'tasks')
                || Object.prototype.hasOwnProperty.call(candidate, 'evaluations')
            ));
        if (!state) return null;
        const rows = (value: any) => Array.isArray(value)
            ? value
            : (value && typeof value === 'object' ? Object.values(value) : []);
        return Object.assign({}, state, {
            projects: rows(state.projects),
            surveys: rows(state.surveys),
            harnesses: rows(state.harnesses),
            tasks: rows(state.tasks),
            evaluations: state.evaluations && typeof state.evaluations === 'object' && !Array.isArray(state.evaluations)
                ? state.evaluations
                : {}
        });
    }

    private responseMessage(payload: any, fallback: string) {
        const data = payload && payload.data;
        const error = payload && payload.error;
        return String(payload && payload.message
            || data && data.message
            || error && (error.message || error)
            || fallback);
    }

    public isAdmin() {
        return this.service.auth.check.role('admin');
    }

    public canAccessTask() {
        if (this.isAdmin()) return true;
        const session = this.service.auth.session || {};
        const email = String(session.email || '').trim().toLowerCase();
        const id = String(session.id || '').trim();
        const hasAssignment = !!String(this.task.assigneeEmail || '').trim() || !!String(this.task.assigneeId || '').trim();
        return !hasAssignment
            || (!!email && email === String(this.task.assigneeEmail || '').toLowerCase())
            || (!!id && id === String(this.task.assigneeId || ''));
    }

    public backRoute() {
        return this.kind === 'kg' ? '/kg-reviews' : '/human-reviews';
    }

    public taskRoute() {
        return '/review-tasks/' + this.kind + '/' + this.task.id;
    }

    public kindLabel() {
        return this.kind === 'kg' ? 'KG 검수 결과' : 'QA 검수 결과';
    }

    public hasResult() {
        return !!this.evaluation.submitted;
    }

    public averageScore() {
        const serverScore = this.optionalNumber(this.evaluation.score);
        if (serverScore !== null) return Math.round(serverScore * 10) / 10;
        const scores = this.surveyDimensions
            .map((dimension: any) => Number(this.evaluation.scores[dimension.key]) || 0)
            .filter((score: number) => score > 0);
        if (!scores.length) return 0;
        return Math.round(scores.reduce((sum: number, score: number) => sum + score, 0) / scores.length * 20);
    }

    public scoreValue(key: string) {
        return Number(this.evaluation.scores[key]) || 0;
    }

    public scorePercent(key: string) {
        return this.scoreValue(key) * 20;
    }

    public usesCategoricalSurvey() {
        return this.surveyDimensions.length > 0
            && this.surveyDimensions.every((item: any) => Array.isArray(item.responseOptions) && item.responseOptions.length > 0);
    }

    public responseLabel(dimension: any) {
        const value = String(this.evaluation.responses && this.evaluation.responses[dimension.key] || '');
        const option = (dimension.responseOptions || []).find((item: any) => item.value === value);
        return option ? option.label : '응답 없음';
    }

    public isDelegatedAiReview() {
        const reviewMode = String(
            this.task.review_mode || this.task.reviewMode || ''
        ).trim().toLowerCase();
        const reviewerKind = String(
            this.task.reviewer_kind || this.task.reviewerKind || ''
        ).trim().toLowerCase();
        return reviewMode === 'delegated_ai'
            || this.task.not_human_review === true
            || this.task.notHumanReview === true
            || reviewerKind === 'codex_delegated_ai_quality_reviewer';
    }

    public isHumanReleasePending() {
        return String(
            this.task.human_release_status || this.task.humanReleaseStatus || ''
        ).trim().toLowerCase() === 'pending';
    }

    public reviewScoreEyebrow() {
        return this.isDelegatedAiReview()
            ? 'AI QUALITY REVIEW SCORE'
            : 'FINAL REVIEW SCORE';
    }

    public reviewScoreTitle() {
        return this.isDelegatedAiReview()
            ? 'AI 품질 검수 점수'
            : '종합 검수 점수';
    }

    public decisionEyebrow() {
        return this.isDelegatedAiReview()
            ? 'AI QUALITY GATE'
            : 'FINAL DECISION';
    }

    public humanReleaseLabel() {
        const status = String(
            this.task.human_release_status || this.task.humanReleaseStatus || ''
        ).trim().toLowerCase();
        if (status === 'pending' || (!status && this.isDelegatedAiReview())) {
            return '대기 중';
        }
        if (status === 'released' || status === 'approved') return '완료';
        return '기록 없음';
    }

    public decisionMeta() {
        if (this.evaluation.decision === 'revise') {
            return {
                label: '수정 필요',
                description: this.isDelegatedAiReview()
                    ? 'AI 품질 게이트에서 보완이 필요한 결과입니다.'
                    : '보완 후 다시 확인해야 하는 결과입니다.',
                className: 'is-revise',
                icon: 'fa-solid fa-pen-to-square'
            };
        }
        if (this.evaluation.decision === 'exclude') {
            return {
                label: '사용 제외',
                description: this.isDelegatedAiReview()
                    ? 'AI 품질 검수 대상에서 제외된 결과입니다.'
                    : '최종 결과에서 제외된 검수 결과입니다.',
                className: 'is-exclude',
                icon: 'fa-solid fa-circle-xmark'
            };
        }
        if (this.evaluation.decision === 'verify') {
            return {
                label: '자료 확인 필요',
                description: '원문 또는 추가 자료를 확인한 뒤 최종 판정해야 합니다.',
                className: 'is-revise',
                icon: 'fa-solid fa-magnifying-glass'
            };
        }
        if (this.isDelegatedAiReview()) {
            return {
                label: 'AI 품질 게이트 통과',
                description: this.isHumanReleasePending()
                    ? '위임형 AI 품질 검수를 통과했습니다. 사람 release 대기 상태이며 아직 운영 사용 승인이 아닙니다.'
                    : '위임형 AI 품질 검수를 통과했습니다. 사람 release 상태를 별도로 확인해야 합니다.',
                className: 'is-approve',
                icon: 'fa-solid fa-circle-check'
            };
        }
        if (this.isHumanReleasePending()) {
            return {
                label: '사람 release 대기',
                description: '검수 결과는 제출됐지만 사람 release 완료 전에는 운영에 사용할 수 없습니다.',
                className: 'is-revise',
                icon: 'fa-solid fa-clock'
            };
        }
        return { label: '사용 가능', description: '현재 결과를 운영에 사용할 수 있습니다.', className: 'is-approve', icon: 'fa-solid fa-circle-check' };
    }

    public issueLabels() {
        const labels: any = {
            Q_INVALID: '질문 부적절',
            Q_VALUE: '질문 값 오류',
            FACT_ERROR: '사실 오류',
            EVIDENCE_GAP: '근거 부족',
            QA_MISMATCH: '질문·답변 불일치',
            CONTEXT_GAP: '맥락 누락',
            LABEL_MISMATCH: '라벨 불일치',
            CONTENT_MISSING: '내용 누락',
            DATA_NOISE: '불필요한 내용',
            PROJECT_RULE: '프로젝트 기준 위반',
            DUPLICATE: '중복',
            EXPRESSION: '표현 개선'
        };
        const snapshot = this.task && (this.task.survey_snapshot || this.task.surveySnapshot) || {};
        const options = Array.isArray(snapshot.issueOptions)
            ? snapshot.issueOptions
            : (Array.isArray(snapshot.issue_options) ? snapshot.issue_options : []);
        options.forEach((option: any) => {
            const code = String(option?.code || option?.value || '').trim();
            const label = String(option?.label || option?.name || '').trim();
            if (code && label) labels[code] = label;
        });
        return (this.evaluation.issues || []).map((code: string) => labels[code] || code);
    }

    public submittedAtLabel() {
        if (!this.evaluation.submittedAt) return '기록 없음';
        const value = new Date(this.evaluation.submittedAt);
        if (Number.isNaN(value.getTime())) return String(this.evaluation.submittedAt);
        const date = value.toLocaleDateString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit' });
        const time = value.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
        return date + ' ' + time;
    }

    public durationLabel() {
        const minutes = Number(this.evaluation.durationMinutes) || 0;
        if (!minutes) return '기록 없음';
        return minutes < 60 ? minutes.toFixed(1) + '분' : Math.floor(minutes / 60) + '시간 ' + Math.round(minutes % 60) + '분';
    }

    public resultVersionLabel() {
        return String(this.evaluation.version || this.task.resultVersion || this.task.harnessVersion || '—');
    }

    public printResult() {
        if (typeof window !== 'undefined') window.print();
    }

    private emptyEvaluation() {
        return { scores: {}, responses: {}, decision: null, issues: [], problemLocation: '', comment: '', request: '', submitted: false, submittedAt: null, durationMinutes: null, score: null, version: '', target: 90, viewed_samples: [] };
    }

}

export default PageReviewResultItemComponent;